import { DataFilter } from '@siclop/kstone-vue'

export class ProjectTypeFilter extends DataFilter {
  code?: string
  label?: string
  isActive?: boolean

  constructor(data?: Partial<ProjectTypeFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
      this.isActive = data.isActive
    }
  }
}
